import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import useMaterialAndColor from '@/shared/product/customizer/ui/overlays/material-and-color/useMaterialAndColor';
import type { Component } from 'vue';
import SearchFacetColors from '@/shared/product/customizer/ui/overlays/material-and-color/SearchFacetColors.vue';
import SearchFacetColorsSkeleton from '@/shared/product/customizer/ui/overlays/material-and-color/SearchFacetColorsSkeleton.vue';
import SearchFacetMaterials from '@/shared/product/customizer/ui/overlays/material-and-color/SearchFacetMaterials.vue';
import SearchFacetMaterialsSkeleton from '@/shared/product/customizer/ui/overlays/material-and-color/SearchFacetMaterialsSkeleton.vue';
import SearchFacetUnknown from '@/shared/product/customizer/ui/overlays/material-and-color/SearchFacetUnknown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFacets',
  setup(__props) {

const { facets, isPending } = useMaterialAndColor();

const getFacetComponentById = (id?: string): Component => {
    switch (id) {
    case 'colors':
        return SearchFacetColors;
    case 'primaryMaterials':
        return SearchFacetMaterials;
    default:
        return SearchFacetUnknown;
    }
};


return (_ctx: any,_cache: any) => {
  return (_unref(isPending))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(SearchFacetColorsSkeleton),
        _createVNode(SearchFacetMaterialsSkeleton)
      ]))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(facets), (facet, idx) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(getFacetComponentById(facet.id)), {
          key: facet.id+idx,
          facet: facet
        }, null, 8, ["facet"]))
      }), 128))
}
}

})